import { render, staticRenderFns } from "./DebtInstallmentTable.vue?vue&type=template&id=c5a43d16&scoped=true"
import script from "./DebtInstallmentTable.vue?vue&type=script&lang=js"
export * from "./DebtInstallmentTable.vue?vue&type=script&lang=js"
import style0 from "./DebtInstallmentTable.vue?vue&type=style&index=0&id=c5a43d16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a43d16",
  null
  
)

export default component.exports